export const ALERT_SNOOZE_REQUEST = 'ALERT_SNOOZE_REQUEST';
export const ALERT_SNOOZE_SUCCESS = 'ALERT_SNOOZE_SUCCESS';
export const ALERT_SNOOZE_FAILURE = 'ALERT_SNOOZE_FAILURE';

export const ALERT_DISCARD_REQUEST = 'ALERT_DISCARD_REQUEST';
export const ALERT_DISCARD_SUCCESS = 'ALERT_DISCARD_SUCCESS';
export const ALERT_DISCARD_FAILURE = 'ALERT_DISCARD_FAILURE';

export const SEVERITY_ERROR = 1;
export const SEVERITY_WARNING = 2;
export const SEVERITY_INFO = 3;
